export default __webpack_public_path__ + "alberta-picture.09b69bff161c615c7ec6.svg";